import { getMainImageSrcForObj, Tab } from "@touche-lts/panel-ui/dist";
import cl from "classnames";
import { useRootStore } from "mobx-stores/store-provider";
import { StoreDTO } from "models";
import { useState } from "react";
import { User } from "services";
import { restrictUserRolesToAccessStore } from "mobx-stores/stores-public/utils/utils";
import styles from "../header.module.scss";

interface StoreSwitcherProps {
  closeMobileMenu: () => void;
}

export const StoreSwitcher = ({ closeMobileMenu }: StoreSwitcherProps) => {
  const {
    userStore: {
      assignedStore: store,
      setViewerMenuVisible,
      loadAssignedStores,
    },
    routingStore: { push },
    accountStore: { accountDetails },
  } = useRootStore();

  const [optionsHoveredCustomer, setOptionsHoveredCustomer] = useState(false);

  const storePerType = store
    ? store
    : JSON.parse(localStorage.getItem("userDetails"));
  const userRole = JSON.parse(localStorage.getItem("userDetails"))?.role?.name;
  const userStores = JSON.parse(localStorage.getItem("assignedStores"));

  const onHover = (showOptions: boolean): void => {
    setOptionsHoveredCustomer(showOptions);
    if (
      User.isAuthenticated &&
      !restrictUserRolesToAccessStore.includes(userRole)
    ) {
      setTimeout(() => {
        loadAssignedStores();
      }, 10000);
    }
  };

  const switchStore = (targetStore: StoreDTO) => {
    const userStore = JSON.parse(localStorage.getItem("UserStore"));
    userStore.assignedStore = targetStore;
    localStorage.setItem("UserStore", JSON.stringify(userStore));
    window.location.replace("/my-store");
  };

  return (
    <div
      className={cl(styles.storeSwitcher, "d-flex flex-column")}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <Tab
        colorPreset="dark"
        label={
          storePerType?.name ? storePerType?.name : storePerType?.firstName
        }
        imageUrl={accountDetails?.imageUrl}
        imageShape="portrait"
        isSelected
        onClick={() => {
          setViewerMenuVisible(true);
          push("/account/details");
          closeMobileMenu();
        }}
        className={styles.tab}
      />
      {optionsHoveredCustomer &&
        !restrictUserRolesToAccessStore.includes(userRole) && (
          <div
            className={cl(styles.menuHovered, styles.thinScroll)}
            onClick={() => push("/my-store")}
          >
            {userStores &&
              userStores
                .filter((s) => s?.id !== store?.id)
                .map((storeItem) => (
                  <Tab
                    colorPreset="dark"
                    label={
                      (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            maxWidth: "190px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            marginRight: "10px",
                          }}
                          className={styles.storeLabel}
                        >
                          {storeItem.backgroundCrop &&
                            storeItem.backgroundCrop.url && (
                              <img
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  marginRight: "15px",
                                  objectFit: "cover",
                                }}
                                src={storeItem.backgroundCrop.url}
                                alt={storeItem.name || storeItem.firstName}
                                className={styles.storeImage}
                              />
                            )}
                          {storeItem.name
                            ? storeItem.name
                            : storeItem.firstName}
                        </div>
                      ) as any
                    }
                    imageUrl={getMainImageSrcForObj(storeItem)}
                    imageShape="portrait"
                    isSelected
                    className={styles.tab}
                    onClick={() => switchStore(storeItem)}
                    key={`${storeItem.name}-${storeItem.id}`}
                  />
                ))}
          </div>
        )}
    </div>
  );
};
